module.exports = __webpack_public_path__ + "static/media/santa-hat.1cc2ced0.svg";